/**
 * Machine-readable reason an auth guard denied a request.
 *
 * Clients drive control flow off the HTTP status — 401 means "your credentials
 * are missing or stale, refresh and retry", 403 means "your credentials are
 * fine, you just may not do this". These codes exist for observability and so
 * the two cases can diverge later without another round of string matching.
 */
export enum AuthErrorCode {
  TOKEN_MISSING = "AUTH_TOKEN_MISSING",
  TOKEN_INVALID = "AUTH_TOKEN_INVALID",
  TOKEN_EXPIRED = "AUTH_TOKEN_EXPIRED",
  USER_NOT_FOUND = "AUTH_USER_NOT_FOUND",
  INSUFFICIENT_ROLE = "AUTH_INSUFFICIENT_ROLE",
  STORE_UNRESOLVED = "AUTH_STORE_UNRESOLVED",
  ROUTE_MISCONFIGURED = "AUTH_ROUTE_MISCONFIGURED",
}

const TOKEN_ERROR_CODES: string[] = [
  AuthErrorCode.TOKEN_MISSING,
  AuthErrorCode.TOKEN_INVALID,
  AuthErrorCode.TOKEN_EXPIRED,
]

/**
 * True for the 401s a fresh token could fix. Other 401s — an upstream system
 * rejecting our own credentials, say — say nothing about the user's session.
 */
export const isAuthTokenErrorCode = (errorCode: string): boolean =>
  TOKEN_ERROR_CODES.includes(errorCode)
